export default {
  title: 'Elenco Pricing Plans Membership',

  elements: [
    {
      type: 'dataTable',
      config: {
        url: 'membership-prices',
        response: {
          mappers: {
            list: 'data'
          }
        },

        pagination: {
          mappers: {
            count: 'meta.total',
            perPage: 'meta.per_page'
          }
        },
        columns: [
          {
            label: 'Name',
            field: 'name',
            sortable: true
          },
          {
            label: 'Created',
            field: 'created_at',
            widget: 'datetime',
            sortable: true
          }
        ]
      }
    }
  ]
};
